// ------------------------------------------------------------------------------
// name: activity - 活动中心相关接口
// author: mudas
// created: 2025/6/13
// ------------------------------------------------------------------------------

import { FastApiAxiosInstance } from 'common/service/axiosInstances';
import { PaginationResult } from 'common/types';
import { ActivityDraft, ActivityInfo, ActivityMediaType, ExcellentWorks, TiangongActivity } from '@tiangong/types';
import { CDN_URL } from '@/pages/ActivityCenter/activities/common/constants';

const activity = {
  // 获取活动列表
  getActivityList: async () => {
    return FastApiAxiosInstance.get<TiangongActivity[]>('/api/v1/activity/list');
  },

  // 获取活动详情
  getActivityDetail: async ({ code }: { code: string }) => {
    return FastApiAxiosInstance.get<TiangongActivity>('/api/v1/activity/details', {
      params: { code },
    });
  },

  // 获取活动信息：报名人数，是否已报名 /api/v1/activity/info
  getActivityInfo: async ({ activityId }: { activityId: number }) => {
    return FastApiAxiosInstance.get<ActivityInfo>('/api/v1/activity/info', {
      params: { activityId },
    });
  },

  // 提交活动报名申请 /api/v1/activity/apply
  applyActivity: async ({ activityId, repeated }: { activityId: number; repeated?: boolean }) => {
    return FastApiAxiosInstance.post('/api/v1/activity/apply', { activityId, repeated });
  },

  // 目前支持的社媒平台类型
  getMediaTypes: () => {
    // return FastApiAxiosInstance.get<ActivityMediaType[]>(
    //   '/api/v1/backend/mediaUser/linkTypes',
    // );

    // 与以上接口数据对应，但目前仅有限量的开放部分类型给予活动中使用
    return Promise.resolve({
      code: 0,
      data: [
        {
          value: 5,
          label: '抖音',
          icon: 'douying',
          example: 'https://www.douyin.com/user/MS4wLjABAAAAxzQBxVdJGeRupP79HyWo7MSN7lSrFim5zhD5mhVvI4Q',
          homepageExample: `${CDN_URL}/activity-center/shared/home-dy.png`,
          tips: '打开抖音作品>更多>分享链接 再粘贴至此处',
        },
        {
          value: 11,
          label: '小红书',
          icon: 'redbook',
          example: 'https://www.xiaohongshu.com/user/profile/60d17b1f000000000101e7d9',
          homepageExample: `${CDN_URL}/activity-center/shared/home-xhs.png`,
          tips: '打开笔记>分享>复制链接 再粘贴至此处',
        },
        {
          value: 12,
          label: '微博',
          icon: 'weibo',
          example: 'https://weibo.com/u/6036759885',
          homepageExample: `${CDN_URL}/activity-center/shared/home-wb.png`,
          tips: '打开微博正文>右上角……>复制链接 再粘贴至此处',
        },
      ] as ActivityMediaType[],
    });
  },

  // 活动投稿
  submitDraft: async (params: ActivityDraft) => {
    return FastApiAxiosInstance.post('/api/v1/activity/contribute', params);
  },

  // 活动投稿记录
  getDraftList: async (params: { activityId: number }) => {
    return FastApiAxiosInstance.get<PaginationResult<ActivityDraft>>('/api/v1/activity/contribute/history', {
      params,
    });
  },

  // 获取优秀作品
  getExcellentWorks: async (params: { activityId: number }) => {
    return FastApiAxiosInstance.get<ExcellentWorks[]>('/api/v1/activity/excellentWork', { params });
  },
};

export default activity;
